import React from 'react';
interface SectionHeadingProps {
  title: string;
  intro?: string;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
  action?: React.ReactNode;
}
export function SectionHeading({
  title,
  intro,
  align = 'left',
  tone = 'light',
  action
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className={`flex flex-col gap-4 ${align === 'center' ? 'items-center text-center' : 'md:flex-row md:items-end md:justify-between'}`} data-id="element-131" data-mp="3kwjc87c5uwfq">
      <div className={align === 'center' ? 'max-w-2xl' : 'max-w-2xl'} data-id="element-132" data-mp="hehwzd4d6jfj">
        <h2 className={`text-3xl font-bold leading-tight md:text-[38px] ${isDark ? 'text-white' : 'text-ink'}`} data-id="element-133" data-mp="hgko60h96ilu">
          {title}
        </h2>
        {intro && <p className={`mt-3 text-[17px] leading-relaxed ${isDark ? 'text-brand-200' : 'text-ink-muted'}`} data-id="element-134" data-mp="veizex0a1yx4">
            {intro}
          </p>}
      </div>
      {action && <div className="shrink-0" data-id="element-135" data-mp="106k9cc9z3djz">{action}</div>}
    </div>;
}